import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { CandidateProfile } from "../../../Redux/action/CandidateProfileAction";
import { CandidateEducationAction } from "../../../Redux/action/CandidateEducationAction";
import {
  getBoardsList,
  getGraduationList,
} from "../../../Services/GetGradutionList";
import { CiEdit } from "react-icons/ci";
import { RiForbid2Line } from "react-icons/ri";
import { toast, ToastContainer } from "react-toastify";
import { useNavigate } from "react-router";

const EducationalInfo = () => {
  const { userResult } = useSelector((state) => state.Auth);
  const candidateId = userResult?.userid;
  const [graduation, setGraduation] = useState([]);
  const [postGraduation, setPostGraduation] = useState([]);
  const [boardList, setBoardList] = useState([]);
  const [isDisabled, setIsDisabled] = useState(true);
  const [loader, setLoader] = useState(false);

  const [profileInfo, setProfileInfo] = useState([
    {
      educationId: null,
      type: "High School",
      candidateId,
      institutionName: null,
      degreeName: null,
      passingYear: null,
      board: null,
      percentage: null,
      university: null,
      educationStatus: "COMPLETED",
    },
    {
      educationId: null,
      type: "Intermediate",
      candidateId,
      institutionName: null,
      degreeName: null,
      passingYear: null,
      board: null,
      percentage: null,
      university: null,
      educationStatus: "COMPLETED",
    },
    {
      educationId: null,
      type: "Graduation",
      candidateId,
      institutionName: null,
      degreeName: null,
      passingYear: null,
      board: null,
      percentage: null,
      university: null,
      educationStatus: "COMPLETED",
    },
    {
      educationId: null,
      type: "Post Graduation",
      candidateId,
      institutionName: null,
      degreeName: null,
      passingYear: null,
      board: null,
      percentage: null,
      university: null,
      educationStatus: "COMPLETED",
    },
  ]);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const userInfo = useSelector((state) => state?.Profile?.result);

  const handleInputChange = (e, index) => {
    const { name, value, type, checked } = e.target;
    const updatedProfileInfo = [...profileInfo];
    if (name === "educationStatus") {
      if (checked) {
        // If Pursuing → reset passingYear and percentage
        updatedProfileInfo[index] = {
          ...updatedProfileInfo[index],
          educationStatus: "PURSUING",
          passingYear: "",
          percentage: "",
        };
      } else {
        updatedProfileInfo[index].educationStatus = "COMPLETED";
      }
    } else {
      updatedProfileInfo[index][name] =
        type === "number" ? parseInt(value) : value;
    }
    setProfileInfo(updatedProfileInfo);
  };

  const graduationsa = profileInfo.find(
    (item) => item.type === "Graduation"
  )?.educationStatus;

  useEffect(() => {
    const graduation = profileInfo.find(
      (item) => item.type === "Graduation"
    )?.educationStatus;
    const postGraduation = profileInfo.find(
      (item) => item.type === "Post Graduation"
    )?.educationStatus;
    // console.log("object for kkkkkkk", graduation)
    if (graduation === "PURSUING") {
      setProfileInfo((prev) =>
        prev.map((item) =>
          item.type === "Graduation"
            ? { ...item, passingYear: "", percentage: "" }
            : item
        )
      );
      setProfileInfo((prev) =>
        prev.map((item) =>
          item.type === "Post Graduation"
            ? {
                ...item,
                passingYear: null,
                degreeName: "",
                percentage: "",
                university: "",
                institutionName: "",
                educationStatus: "COMPLETED",
              }
            : item
        )
      );
    }
    if (postGraduation === "PURSUING") {
      setProfileInfo((prev) =>
        prev.map((item) =>
          item.type === "Post Graduation"
            ? { ...item, passingYear: "", percentage: "" }
            : item
        )
      );
    }
  }, [graduationsa]);

  useEffect(() => {
    dispatch(CandidateProfile(candidateId));
  }, [isDisabled]);
  console.log("eduatinal info", profileInfo);
  useEffect(() => {
    setProfileInfo((prevProfileInfo) =>
      prevProfileInfo.map((item, index) => ({
        ...item,
        educationId: userInfo?.educations?.[index]?.educationId || null,
        institutionName: userInfo?.educations?.[index]?.institutionName || "",
        degreeName: userInfo?.educations?.[index]?.degreeName || "",
        passingYear: userInfo?.educations?.[index]?.passingYear ?? "",
        board: userInfo?.educations?.[index]?.board ?? "",
        percentage: userInfo?.educations?.[index]?.percentage ?? "",
        university: userInfo?.educations?.[index]?.university ?? "",
        educationStatus:
          userInfo?.educations?.[index]?.educationStatus ?? "COMPLETED",
      }))
    );
  }, [dispatch, userInfo]);

  const handleSubmit = (e) => {
    e.preventDefault();
    // Force educationStatus to "COMPLETED" for High School and Intermediate
    let updatedProfileInfo = profileInfo.map((item) => {
      if (item.type === "High School" || item.type === "Intermediate") {
        return { ...item, educationStatus: "COMPLETED" };
      }
      return item;
    });

    const highSchool = updatedProfileInfo.find(
      (item) => item.type === "High School"
    )?.passingYear;
    const intermediate = updatedProfileInfo.find(
      (item) => item.type === "Intermediate"
    )?.passingYear;
    const graduation = updatedProfileInfo.find(
      (item) => item.type === "Graduation"
    )?.passingYear;
    const graduationStatus = updatedProfileInfo.find(
      (item) => item.type === "Graduation"
    )?.institutionName;
    const graduationInstitute = updatedProfileInfo.find(
      (item) => item.type === "Graduation"
    )?.institutionName;
    const postGraduation = updatedProfileInfo.find(
      (item) => item.type === "Post Graduation"
    )?.passingYear;
    const postInstitute = updatedProfileInfo.find(
      (item) => item.type === "Post Graduation"
    )?.institutionName;

    if (intermediate <= highSchool + 2) {
      toast.error(
        "Intermediate passing year should be greater than High school passing year."
      );
      setProfileInfo((prev) =>
        prev.map((item) =>
          item.type === "Intermediate" ? { ...item, passingYear: "" } : item
        )
      );
      return;
    }

    if (graduationStatus === "COMPLETED" && graduationInstitute) {
      if (graduation < intermediate + 2) {
        toast.error(
          "Graduation passing year should be greater than Intermediate passing year."
        );
        setProfileInfo((prev) =>
          prev.map((item) =>
            item.type === "Graduation" ? { ...item, passingYear: "" } : item
          )
        );
        return;
      }
    }

    if (graduationInstitute) {
      if (postGraduation && postGraduation < graduation + 2) {
        toast.error(
          "Post Graduation passing year should be greater than Graduation passing year."
        );
        setProfileInfo((prev) =>
          prev.map((item) =>
            item.type === "Post Graduation"
              ? { ...item, passingYear: "" }
              : item
          )
        );
        return;
      }
    }

    let newData = updatedProfileInfo;
    if (!postInstitute) {
      newData = updatedProfileInfo.map((item) =>
        item.type === "Post Graduation"
          ? {
              ...item,
              passingYear: null,
              degreeName: "",
              percentage: "",
              university: "",
              educationStatus: "COMPLETED",
            }
          : item
      );
    }
    if (!graduationInstitute) {
      newData = updatedProfileInfo.map((item) =>
        item.type === "Graduation"
          ? {
              ...item,
              passingYear: null,
              degreeName: "",
              percentage: "",
              university: "",
              educationStatus: "COMPLETED",
            }
          : item
      );
    }
    const isValid = true;
    if (isValid) {
      setLoader(true);
      dispatch(CandidateEducationAction(newData, navigate))
        .then(() => {
          setIsDisabled(!isDisabled);
          setLoader(false);
        })
        .catch((error) => {
          setLoader(false);
        });
    } else {
      toast.error("Please fill all required fields.");
    }
  };

  const handleEdit = () => setIsDisabled(!isDisabled);

  const currentYear = new Date().getFullYear();
  const years = Array.from({ length: currentYear - 1969 }, (_, i) => 1970 + i);

  useEffect(() => {
    window.scrollTo(0, 0);
    getGraduationList("graduation").then((res) =>
      setGraduation(res?.data?.data)
    );
    getGraduationList("postGraduation").then((res) =>
      setPostGraduation(res?.data?.data)
    );
    getBoardsList().then((res) => setBoardList(res?.data?.data));
  }, []);

  return (
    <>
      <ToastContainer />
      <div className="mx-3">
        <div className="row d-flex justify-content-center align-items-center">
          <div className="card can_prof_main">
            <div className="card-header prof_header d-flex justify-content-between">
              Educational
              <span>
                {isDisabled ? (
                  <CiEdit onClick={handleEdit} className="pointer" />
                ) : (
                  <RiForbid2Line
                    color="red"
                    onClick={handleEdit}
                    className="pointer"
                  />
                )}
              </span>
            </div>
            <div className="card-body">
              <form onSubmit={handleSubmit}>
                <div className="row gx-3 mb-3">
                  {profileInfo.map((education, index) => (
                    <React.Fragment key={index}>
                      <div className="col-sm-6">
                        <label className="small mb-1">
                          {education.type}
                          {education.type !== "Post Graduation" && (
                            <span style={{ color: "red", paddingLeft: 4 }}>
                              *
                            </span>
                          )}
                        </label>
                        <input
                          required={[
                            "High School",
                            "Intermediate",
                            "Graduation",
                          ].includes(education.type)}
                          className="form-control"
                          type="text"
                          name="institutionName"
                          maxLength="250"
                          placeholder={`Enter ${education.type} institution name`}
                          value={education.institutionName || ""}
                          onChange={(e) => handleInputChange(e, index)}
                          disabled={
                            isDisabled ||
                            (education.type === "Post Graduation" &&
                              graduationsa === "PURSUING")
                          }
                        />
                      </div>
                      {["Graduation", "Post Graduation"].includes(
                        education.type
                      ) && (
                        <div className="col-sm-3">
                          <label className="small mb-1">
                            Degree Name
                            {(education.type !== "Post Graduation" ||
                              education.institutionName) && (
                              <span style={{ color: "red", paddingLeft: 4 }}>
                                *
                              </span>
                            )}
                          </label>
                          <select
                            required
                            className="form-control"
                            name="degreeName"
                            value={education.degreeName || ""}
                            onChange={(e) => handleInputChange(e, index)}
                            disabled={isDisabled || !education.institutionName}
                          >
                            <option value="" disabled>
                              Select Degree
                            </option>
                            {(education.type === "Graduation"
                              ? graduation
                              : postGraduation
                            )?.map((degree) => (
                              <option
                                key={degree.degreeId}
                                value={degree.degreeName}
                              >
                                {degree.degreeName}
                              </option>
                            ))}
                          </select>
                        </div>
                      )}

                      <div
                        className={
                          ["Graduation", "Post Graduation"].includes(
                            education.type
                          )
                            ? "col-sm-3"
                            : "col-sm-6"
                        }
                      >
                        <label className="small mb-1">
                          Passing Year
                          {(education.type !== "Post Graduation" ||
                            education.institutionName) && (
                            <span style={{ color: "red", paddingLeft: 4 }}>
                              *
                            </span>
                          )}
                        </label>
                        <select
                          className="form-control"
                          required
                          name="passingYear"
                          value={education.passingYear || ""}
                          onChange={(e) => handleInputChange(e, index)}
                          disabled={
                            isDisabled ||
                            !education.institutionName ||
                            education.educationStatus === "PURSUING"
                          }
                        >
                          <option value="">Select Year</option>
                          {years.map((year) => (
                            <option key={year} value={year}>
                              {year}
                            </option>
                          ))}
                        </select>
                      </div>

                      {["High School", "Intermediate"].includes(
                        education.type
                      ) && (
                        <div className="col-sm-6">
                          <label className="small mb-1">
                            Board
                            <span style={{ color: "red", paddingLeft: 4 }}>
                              *
                            </span>
                          </label>
                          <select
                            required
                            className="form-control"
                            name="board"
                            value={education.board || ""}
                            onChange={(e) => handleInputChange(e, index)}
                            disabled={isDisabled || !education.institutionName}
                          >
                            <option value="">Select Board</option>
                            {boardList?.map((board) => (
                              <option
                                key={board.boardName}
                                value={board.boardName}
                              >
                                {board.boardName}
                              </option>
                            ))}
                          </select>
                        </div>
                      )}
                      {["Graduation", "Post Graduation"].includes(
                        education.type
                      ) && (
                        <div className="col-sm-6">
                          <label className="small mb-1">
                            University
                            <span style={{ color: "red", paddingLeft: 4 }}>
                              *
                            </span>
                          </label>
                          <input
                            className="form-control"
                            type="text"
                            required
                            name="university"
                            maxLength="250"
                            placeholder={`Enter ${education.type} university`}
                            value={education.university || ""}
                            onChange={(e) => handleInputChange(e, index)}
                            disabled={isDisabled || !education.institutionName}
                          />
                        </div>
                      )}
                      <div className="col-sm-6">
                        <label className="small mb-1">
                          Percentage
                          <span style={{ color: "red", paddingLeft: 4 }}>
                            *
                          </span>
                        </label>
                        <input
                          className="form-control"
                          type="number"
                          name="percentage"
                          required
                          min={34}
                          max={100}
                          value={education.percentage || ""}
                          onChange={(e) => handleInputChange(e, index)}
                          disabled={
                            isDisabled ||
                            !education.institutionName ||
                            education.educationStatus === "PURSUING"
                          }
                        />
                      </div>
                      {["Graduation", "Post Graduation"].includes(
                        education.type
                      ) && (
                        <div className="col-sm-6">
                          <div
                            className="form-check d-flex align-items-center gap-2"
                            style={{ minHeight: "18px" }}
                          >
                            <input
                              className="form-check-input mt-2"
                              type="checkbox"
                              id={`educationStatus-${index}`}
                              name="educationStatus"
                              checked={education.educationStatus === "PURSUING"}
                              onChange={(e) => handleInputChange(e, index)}
                              disabled={
                                isDisabled || !education.institutionName
                              }
                              style={{
                                width: "15px",
                                height: "15px",
                                padding: "8px",
                                cursor:
                                  isDisabled || !education.institutionName
                                    ? "not-allowed"
                                    : "pointer",
                              }}
                            />
                            <label
                              htmlFor={`educationStatus-${index}`}
                              className="form-check-label mb-0"
                              style={{
                                fontSize: "15px",
                                color: "#333",
                                cursor:
                                  isDisabled || !education.institutionName
                                    ? "not-allowed"
                                    : "pointer",
                              }}
                            >
                              Pursuing
                            </label>
                          </div>
                        </div>
                      )}
                      <hr style={{ marginTop: "10px" }} />
                    </React.Fragment>
                  ))}
                </div>
                {!isDisabled && (
                  <button
                    disabled={loader}
                    className="can_update_prof_btn add_skill_btn"
                    type="submit"
                  >
                    {loader ? "Loading" : "Save changes"}
                  </button>
                )}
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default EducationalInfo;
